import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, History } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { usePaged } from "@/lib/hooks";
import { fmtDateTime } from "@/lib/api";
import { Pager } from "@/components/core/Pager";

const ActivityList = () => {
  const [q, setQ] = useState("");
  const [dq, setDq] = useState("");
  useEffect(() => { const t = setTimeout(() => setDq(q), 250); return () => clearTimeout(t); }, [q]);
  const paged = usePaged("/activities", dq ? { q: dq } : {}, 25);
  return (
    <div data-testid="activity-log">
      <div className="relative mb-3"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per socio, azione o elemento" className="rounded-full pl-9" data-testid="activity-log-search" /></div>
      <div className="divide-y divide-[#5FB3EA]/60 min-h-[200px]">
        {(paged.items || []).map((a) => (
          <div key={a.id} className="py-2 text-sm" data-testid={`activity-log-row-${a.id}`}>
            <span className="font-bold text-[#0A1128]">{a.user_nome}</span> {a.azione}{" "}
            {a.client_id && a.target_tipo === "cliente" ? <Link to={`/clienti/${a.client_id}`} className="font-bold text-[#0A1128] hover:text-[#E8173A]">{a.target_nome}</Link> : <span className="font-semibold">{a.target_nome}</span>}
            <div className="text-[11px] text-slate-500">{fmtDateTime(a.created_at)}</div>
          </div>
        ))}
        {paged.items && !paged.items.length && <div className="py-6 text-center text-sm text-slate-600">Nessuna attività trovata.</div>}
      </div>
      <Pager data={paged.data} page={paged.page} setPage={paged.setPage} testid="activity-log-pager" />
    </div>
  );
};

export const ActivityLogButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} className="mt-5 rounded-full font-bold w-full" data-testid="activity-log-open"><History className="h-4 w-4 mr-1.5" />Registro attività completo</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto core-scroll rounded-2xl" data-testid="activity-log-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl font-black text-[#0A1128]">Registro attività</DialogTitle></DialogHeader>
          {open && <ActivityList />}
        </DialogContent>
      </Dialog>
    </>
  );
};
